import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';


@Component({
  selector: 'app-course-schedule-dialog-box',
  templateUrl: './course-schedule-dialog-box.component.html', 
  styleUrls: ['./course-schedule-dialog-box.component.scss']
})
export class CourseScheduleDialogBoxComponent implements OnInit {
  CourseSchForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  public obj: any = {};
  showSubmitButton = true;
  CShCoCode: any;
  list;
  isread = false;
  isreaddelete = false;
  APIService: any;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  courseList: any;
  filteredListCourse: any;
  ExamName: any;
  ImagePath: any;
  BranchList: any;
  filteredListBranch: any;
  coursecheduleList: any;
  filteredListCoSch: any;
  userPermission:any;
  utp: any;
  CourseScCreate = true;
CourseScUpdate = true;
CourseScDelete = true;
  SessionNo: any;
  // jsonData: any;
  sessionList: any[] = [];
  filteredSessionList: any[] = [];

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<CourseScheduleDialogBoxComponent>,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
    private spinner:NgxSpinnerService, private dialog:MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
     ) { this.APIService = environment.serviceUrl; }

     ngOnInit(): void {
      if(JSON.parse(sessionStorage.getItem("session")) == null){
        this.fetchSecretData();
      }
      else if(JSON.parse(sessionStorage.getItem("session")) != null){
        let sessionData = JSON.parse(sessionStorage.getItem("session"));
        this.SessionNo = sessionData.SnNo;
        // this.getCoSchData(this.SessionNo);
        // this.fetchCourseData(this.SessionNo);
        // this.CourseSchForm.controls['CShSnNo'].setValue(this.SessionNo);
      }
      this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
      this.utp = sessionStorage.getItem('usertypeee');
      if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
        // this.isSuperAdmin= false;
        this.userPermission.forEach(element => {
        if(element.PageName == 'Course-Schedule' && element.PCreate == false)
        {
            this.CourseScCreate = false;  
        }
        if(element.PageName == 'Course-Schedule' && element.PUpdate == false)
        {
            this.CourseScUpdate = false;  
        }   
        if(element.PageName == 'Course-Schedule' && element.PDelete == false)
        {
            this.CourseScDelete = false;  
        } 
      });
    }
      window.scroll(0, 0);
      this.submitButton = true;
      this.editButton = false;
      this.deleteButton = false;
      this.list = true;
      this.CourseSchForm = this.fb.group({
        CShCoCode: new FormControl ('',Validators.required),
        CoName: new FormControl(''),
        CShStatus: new FormControl('O'),
        CShPath: new FormControl(''),
        CShId: new FormControl(''),
        CShSnNo: new FormControl(this.SessionNo),
        
      });
      this.fetchSessionList();

      if (this.data.key == "Edit") {
        this.prepopulation(this.data.selected);
      } else if (this.data.key == "Delete") {
        this.prepopulationForDelete(this.data.selected);
      } else {  
        // alert(this.data.key)
      }

      this.fetchSecretData1()
      
    }

    fetchSessionList() {
      this.spinner.show();
      const payload = { SnActive: 'Y' };
      this.umsService.getSession(payload).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.sessionList = res.data || [];
            this.filteredSessionList = [...this.sessionList];
          } else {
            this.sessionList = [];
            this.filteredSessionList = [];
          }
        },
        error: (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.sessionList = [];
          this.filteredSessionList = [];
        }
      });
    }
    onSessionChange(sessionId: any) {
      this.SessionNo = sessionId;
      this.CourseSchForm.controls['CShSnNo'].setValue(sessionId);
      // Reset course selection
      this.CourseSchForm.controls['CShCoCode'].setValue('');
      this.CourseSchForm.controls['CoName'].setValue('');
      // Reload course list for the new session
      if (sessionId) {
        this.fetchCourseData(sessionId);
      } else {
        this.courseList = [];
        this.filteredListCourse = [];
      }
    }

    fetchSecretData1() {
      this.umsService.getSecretData().subscribe((res) => {
        // this.SessionNo = res.projectPharam['SnNo']
            this.getCoSchData(this.SessionNo);
            this.fetchCourseData(this.SessionNo);
            this.CourseSchForm.controls['CShSnNo'].setValue(this.SessionNo);
        }
      );
    }
  
    fetchSecretData() {
      this.umsService.getSecretData().subscribe((res) => {
        this.SessionNo = res.projectPharam['SnNo']
        this.getCoSchData(this.SessionNo);
            this.fetchCourseData(this.SessionNo);
            this.CourseSchForm.controls['CShSnNo'].setValue(this.SessionNo);
        }
      );
    }
    
    
  
    getCoSchData(SnNo) {
      this.spinner.show();
      const payload = {};
      payload['LoginId'] = sessionStorage.getItem('userId');
      payload['CShSnNo'] = SnNo;
      this.umsService.getCourseSch(payload).subscribe(res => {
        this.spinner.hide();
        this.coursecheduleList = res.data;
        this.filteredListCoSch = this.coursecheduleList.slice();
        });
    }
  
   
  
    prepopulation(id) {
           this.editButton = true;
           this.isreaddelete = false;
           this.submitButton = false;
           this.isread = true;
           this.deleteButton  = false;
           this.SessionNo = id.CShSnNo || this.SessionNo;
           this.CourseSchForm = this.fb.group({
            CShCoCode: new FormControl (id.CShCoCode,Validators.required),
            CoName: new FormControl(id.CoName),
            CShStatus: new FormControl(id.CShStatus),
            CShPath: new FormControl(id.CShPath),
            CShId: new FormControl(id.CShId),
            CShSnNo: new FormControl(this.SessionNo),
          });
          if (this.SessionNo) {
            this.fetchCourseData(this.SessionNo);
          }
    }
  
     deletee(e, k){
      if (e === 'true'){
        this.list = false;
        this.prepopulationForDelete(k);
      } else {
        this.list = true;
      }
    }
    prepopulationForDelete(id){
          this.editButton = false;
          this.submitButton = false;
          this.isreaddelete = true;
          this.deleteButton = true;
          this.SessionNo = id.CShSnNo || this.SessionNo;
          this.CourseSchForm = this.fb.group({
            CShCoCode: new FormControl (id.CShCoCode,Validators.required),
            CoName: new FormControl(id.CoName),
            CShStatus: new FormControl(id.CShStatus),
            CShPath: new FormControl(id.CShPath),
            CShId: new FormControl(id.CShId),
            CShSnNo: new FormControl(this.SessionNo),
          });
          if (this.SessionNo) {
            this.fetchCourseData(this.SessionNo);
          }
    }
  
    DeletetheRecord(){
      const  data = {};
      data['message'] = 'Are You Sure You Want To Delete This Record ?';
      data['title'] = 'Alert';
      data['icon'] = 'fa fa-question';
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes'){
          this.deletedata(this.CourseSchForm.value);
        }else{
        }
      });
     }
     deletedata(id){
      this.spinner.show();
      const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),  body: {
        CShCoCode: id.CShCoCode,
        CoName: id.CoName,
        CShStatus: id.CShStatus,
        CShPath: id.CShPath,
        CShId: id.CShId,
        CShSnNo: id.CShSnNo
      },
    };
      this.httpClient.delete(this.APIService + '/supervisor/CourseSchedule', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let  data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        });
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
     });
  
     }
  
    submit(){
      if (this.CourseSchForm.invalid) {
        console.log("iiiiiiiiiiii",this.CourseSchForm);
        
        this.CourseSchForm.get('CShCoCode').markAsTouched();
        return;
      } else {
        this.CourseSchedule();
      }
    }
  
    CourseSchedule() {
      this.spinner.show();
      this.submitpayload = this.CourseSchForm.value;
      this.umsService.addCoSch(this.submitpayload).subscribe(res => {
        this.spinner.hide();
        if (res.status){
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            // this.ngOnInit();
          });
        } else {
          this.spinner.hide();
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ngOnInit();
        });
      });
    }
  
    update(){
      if (this.CourseSchForm.invalid) {
        this.CourseSchForm.get('CShCoCode').markAsTouched();
        return;
      } else {
        this.updateCourseSchedule();
      }
    }
  
    updateCourseSchedule() {
      this.spinner.show();
      this.submitpayload = this.CourseSchForm.value;
      this.umsService.updateCoSch(this.submitpayload).subscribe(res => {
        this.spinner.hide();
        if (res.status){
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.ngOnInit();
          });
        } else {
          this.spinner.hide();
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ngOnInit();
        });
      });
    }

    editdata(e, k){
      if (e === 'true'){
        this.list = false;
        this.prepopulation(k);
      } else {
        this.list = true;
      }
    }
  
  
    downloadMyFile(){
      this.spinner.show();
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '../../assets/SampleTemplate.csv');
      link.setAttribute('download', `Sample Template.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      this.spinner.hide();
    }
    redirect(to): void {
      this.router.navigate([to]);
     }
  
    fetchCourseData(SnNo) {
      const payload = {};
      payload['LoginId'] = sessionStorage.getItem('userId');
      payload['CShSnNo'] = SnNo;
      this.umsService.getCoSch(payload).subscribe(res => {
        if(res.status){
          this.courseList = res.data;
        this.filteredListCourse = this.courseList.slice();
        }
        else{
          
        }
      });
    }
    getExam(e){
      this.ExamName = e;
      this.CourseSchForm.controls['CoName'].setValue(e);
    }
    onFileSelect(input) {
      this.ImagePath = input.files[0]['name'];
      this.CourseSchForm.controls['CShPath'].setValue(this.ImagePath);
      // input.files.forEach(element => {
      // });
      // if (input.files && input.files[0]) {
      //   var reader = new FileReader();
      //   reader.onload = (e: any) => {
      //     this.obj.photoUrl = e.target.result;
      //   }
      //   reader.readAsDataURL(input.files[0]);
      // }
    }


    print(){
      this.submitpayload = this.CourseSchForm.value;
      let payload1 = {}
      payload1['EcId'] =this.CourseSchForm.value['CShId'],
      payload1['MenuName'] ='Course Schedule';
      payload1['InCode'] =0;
      payload1['StrTitle'] ='';
      payload1['StrSubTitle'] ='';
      let jsonString = JSON.stringify(payload1);
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        "RptCode": 104,
        "InstName": '',
        "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId":  '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId":  '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": this.CourseSchForm.value['CShCoCode'], //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.SessionNo,
        "Extra1": jsonString,
      }
  
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
      this.dialogRef2.close();
    }
  
}
